import { connect } from 'react-redux';
import * as actions from '../../actions/schedule';
import Schedule from '../../components/schedule/Schedule';

const mapStateToProps = ({ schedule }) => ({
  schedule: schedule.schedule,
  date: schedule.date,
  type: 'student',
});

const mapDispatchToProps = dispatch => ({
  didMount: date => dispatch(actions.schedule(date)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
